<template>
  <div role="search" class="h-[18.3rem]">
    <label for="query" class="hidden pb-3 text-2xl font-futuraEfDemiBold lg-rem:block" data-testid="desktopAndMobileMenuSearchLabel">{{ label }}</label>
    <div class="flex items-start gap-2 pointer-events-auto">
      <div class="relative flex flex-col flex-1">
        <div class="relative flex mb-2 header-search-input">
          <input
            id="query"
            ref="query"
            v-model="inputText"
            type="search"
            style="width: calc(100% - 50px)"
            class="p-3 pl-4 text-lg bg-white bg-no-repeat border-r-0 rounded-l-lg rounded-r-none placeholder:italic h-11 lg:h-10 pr-11 border-1 border-newColors-gray-contentD font-futuraEfBook bg-line-height bg-center-left"
            name="query"
            autocomplete="off"
            :placeholder="placeholder"
            @keyup="keyUpEvents($event)"
            data-testid="desktopAndMobileMenuSearchInput" />
          <button v-if="deleteTextCrossVisible" @click="clearSearchField" type="button" class="mr-4 -ml-8 rounded-sm ellevio-clear-search-field" :aria-label="clearSearchFieldLabel" data-testid="desktopAndMobileMenuSearchInputDeleteCross">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" class="">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 8.182L18.182 0 20 1.818 1.818 20 0 18.182 8.182 10 0 1.818 1.818 0 10 8.182zM18.182 20l-6.73-6.73 1.819-1.817L20 18.182 18.182 20z" fill="#2C2827" />
            </svg>
          </button>
          <!-- desktop (with wrapper) -->
          <ellevio-web-tooltip-wrapper :content="searchTooltipLabel" :active="true" placement="bottom" class="hidden lg:flex" :aria-label="label">
            <button class="items-center justify-center hidden custom-search-button lg:flex" type="submit" :aria-label="label" @click="submitForm" :data-testid="`desktopMenuSearchButton`">
              <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.8554 9.524C9.97207 10.548 8.66793 11.2 7.21229 11.2C4.55993 11.2 2.40293 9.0464 2.40293 6.4C2.40293 3.7528 4.55993 1.6 7.21229 1.6C9.86386 1.6 12.0209 3.7528 12.0209 6.4C12.0209 7.132 11.8509 7.8232 11.5568 8.444L13.0052 9.1264C13.3995 8.2984 13.624 7.376 13.624 6.4C13.624 2.8712 10.7472 0 7.21229 0C3.67581 0 0.799805 2.8712 0.799805 6.4C0.799805 9.9288 3.67581 12.8 7.21229 12.8C8.40982 12.8 9.528 12.4648 10.4875 11.8912L14.6043 16L15.9998 14.6072L10.8554 9.524Z"
                  fill="#0B8454" />
              </svg>
            </button>
          </ellevio-web-tooltip-wrapper>
          <!-- mobile -->
          <button class="block pl-3.5 custom-search-button lg:hidden" :aria-label="label" :data-testid="`mobileMenuSearchButton`">
            <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_3375_3177" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="20"><path d="M0 0H18.963V20H0V0Z" fill="white" /></mask>
              <g mask="url(#mask0_3375_3177)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.545 11.905C11.9835 12.5615 11.2865 13.0886 10.5019 13.4503C9.7174 13.8119 8.86388 13.9994 8 14C4.691 14 2 11.308 2 8C2 4.691 4.691 2 8 2C9.59064 2.00185 11.1156 2.63462 12.2402 3.75947C13.3649 4.88431 13.9974 6.40936 13.999 8C13.999 8.915 13.787 9.779 13.42 10.555L15.227 11.408C15.7351 10.3437 15.9989 9.17934 15.999 8C15.999 3.589 12.41 0 8 0C3.588 0 0 3.589 0 8C0 12.411 3.588 16 8 16C9.43991 15.9996 10.8525 15.6068 12.086 14.864L17.222 20L18.963 18.259L12.545 11.905Z"
                  fill="#0B8454" />
              </g>
            </svg>
          </button>
        </div>
        <ul v-if="showAutoComplete === true && matches && matches.length > 0 && showAutocompleteList" v-click-outside="closeAutoComplete" class="w-full" @keyup.esc="handleEsc">
          <li v-for="(item, index) in matches" :key="index" class="relative flex items-center px-4 py-2 cursor-pointer ellevio-header-search-result-remove-focus group">
            <a tabindex="0" :href="item.url" class="text-lg rounded-sm ellevio-header-search-hit-hightlight" @keyup.enter="autocompleteClick($event)" @click="autocompleteClick($event)" v-html="item.title" />
          </li>
        </ul>
        <ellevio-search-input-error-message v-if="inputText.length > 2 && matches && matches.length === 0 && showAutoComplete && showAutocompleteList" :errorMessage="searchNoHitsContent" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { clickOutside } from '../../../directives/clickOutside'
import EllevioWebTooltipWrapper from '../../web/vue-components/TooltipWrapper.vue'
import EllevioSearchInputErrorMessage from '../../web/vue-components/SearchInputErrorMessage.vue'
import { getBaseUrl } from '../../../helpers/utils'

export default {
  name: 'EllevioWebSearchInput',
  components: {
    EllevioWebTooltipWrapper,
    EllevioSearchInputErrorMessage
  },
  directives: {
    'click-outside': clickOutside
  },
  props: {
    itemIsOpen: {
      type: Boolean,
      default: false
    },
    sizeSmall: {
      type: Boolean,
      default: true
    },
    sizeSearch: {
      type: Boolean,
      default: false
    },
    backgroundBox: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    useInHeader: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    showSearchField: {
      type: Boolean,
      default: false
    },
    numberOfItems: {
      type: Number,
      default: 5
    },
    showAutocompleteList: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    searchTooltipLabel: {
      type: String,
      default: ''
    },
    searchNoHitsContent: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    clearSearchFieldLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showAutoComplete: false,
      hover: [],
      inputText: this.value,
      timer: null,
      getAutocompleteItems: [],
      deleteTextCrossVisible: false
    }
  },
  computed: {
    baseUrl() {
      return getBaseUrl()
    },
    matches() {
      if (this.inputText == '') {
        return []
      }
      let env = {}
      try {
        env = import.meta.env
        if (typeof env !== 'object') env = {}
      } catch (_) {
        env = {}
      }

      if (env.MODE === 'development') {
        return this.getAutocompleteItems.filter((item) => item.title?.toLowerCase().includes(this.inputText.toLowerCase())).slice(0, this.numberOfItems)
      } else {
        return this.getAutocompleteItems.slice(0, this.numberOfItems)
      }
    }
  },
  watch: {
    showSearchField: function (newVal) {
      if (newVal) {
        this.$nextTick(async function () {
          this.$refs.query.focus()
        })
      }
    },
    itemIsOpen: function () {
      this.itemIsOpen ? this.focusSearchField() : this.emptySearchField()
    }
  },
  methods: {
    submitForm() {
      document.forms.searchform.submit()
    },
    emptySearchField() {
      this.inputText = ''
    },
    clearSearchField() {
      this.inputText = ''
      this.deleteTextCrossVisible = false
      this.$refs.query.focus()
    },
    closeAutoComplete() {
      this.showAutoComplete = false
    },
    getData: async function (inputText) {
      const response = await axios.get(`${this.baseUrl}${this.apiUrl}?query=${inputText}&hits=${this.numberOfItems}`)
      const responseData = response.data.data

      return Object.keys(responseData).length === 0 ? [] : responseData
    },
    handleEsc() {
      this.showAutoComplete = false
    },
    keyUpEvents: async function ($event) {
      if (!this.showAutocompleteList) return
      clearTimeout(this.timer)
      this.inputText = $event.target.value
      this.deleteTextCrossVisible = this.inputText.length > 0
      if (this.inputText.length > 2) {
        this.timer = setTimeout(
          async function () {
            this.getAutocompleteItems = await this.getData(this.inputText)
            this.showAutoComplete = true
          }.bind(this),
          150
        )
      } else {
        this.showAutoComplete = false
      }
    },
    autocompleteClick: function () {
      //this.inputText = $event.target.innerText
      this.showAutoComplete = false
    },
    focusSearchField: function () {
      this.$nextTick(async function () {
        this.$refs.query.focus()
      })
    }
  }
}
</script>

<style scoped>
.custom-search-button {
  width: 3.125rem;
  @apply border-1 border-l-0 relative border-newColors-gray-contentD rounded-r-lg  font-futuraEfBook text-lg;
}

.ellevio-clear-search-field svg {
  height: 1rem;
  width: 1rem;
}

.custom-search-button::before {
  @apply content-[''] bg-newColors-gray-contentD absolute left-0 top-1 bottom-1 w-[1px];
}

.custom-search-button svg {
  height: 1.25rem;
  width: 1.1875rem;
}

.ellevio-header-search-hit-hightlight :deep(span) {
  @apply font-futuraEfDemiBold;
}

input[type='search'][autocomplete]:focus {
  @apply border-1 border-r-0 border-newColors-gray-contentD !important;
}

.header-search-input:hover {
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
}
</style>
